"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

// a zip + map, but I do not find we need it much, so no need to generalize
exports.default = function (history) {
    return history.times.map(function (t, idx) {
        return {
            epoch: +t,
            quote: +history.prices[idx]
        };
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/ticks/historyToTicks.js
// module id = 118
// module chunks = 0